var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('j-select-user-by-dep',{attrs:{"value":_vm._f("hiddenId")(_vm.value),"disabled":_vm.disabled},on:{"changes":_vm.handleUserChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }